import { FormElementTypeId } from '@packages/clients';

/**
 * Element type classification constants used by worksheet validation functions.
 * Groups FormElementTypeId values by their validation behavior (read-only,
 * input-based, file-based, conditional, grid-based).
 *
 * Arrays are typed as `string[]` so that entity types (which use `string` for
 * worksheetElementTypeId rather than the DTO's `FormElementTypeId` enum) can
 * be checked with `.includes()` without type errors.
 */
export const WORKSHEET_ELEMENT_TYPE_GROUPS = {
    /** Element types that support conditional (show/hide) child elements. */
    conditionalOptionFormElementTypes: [FormElementTypeId.Radio, FormElementTypeId.Checkbox] as string[],

    /** Element types whose answer is a file upload. */
    fileFormElementTypes: [FormElementTypeId.File] as string[],

    /** Element types that use a grid layout for answers. */
    gridElementTypes: [
        FormElementTypeId.DynamicGrid,
        FormElementTypeId.PressureTestGrid,
        FormElementTypeId.ValveClearanceGrid,
        FormElementTypeId.VehicleNoiseGrid,
    ] as string[],

    /** Element types whose answer is free-text input. */
    inputFormElementTypes: [
        FormElementTypeId.InputText,
        FormElementTypeId.InputTextarea,
        FormElementTypeId.Date,
        FormElementTypeId.Time,
        FormElementTypeId.DateTime,
    ] as string[],

    /** The element type that combines a rating selection with an optional text area. */
    ratingWithTextArea: FormElementTypeId.RatingWithText as string,

    /** Element types that are display-only and never require an answer. */
    readOnlyFieldElementTypes: [FormElementTypeId.TextHeader, FormElementTypeId.TextParagraph] as string[],
};
